<template>
  <section v-loading.fullscreen.lock="loading">
    <div class="contrast">
      <div class="selector">
        <span class="words">区域</span>
        <el-select
          v-model="requestParams1.area_id"
          class="area"
          placeholder="请选择"
          clearable
        >
          <el-option
            v-for="(item, index) in areas"
            :key="index"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
        <span class="words">学校类别</span>
        <el-select
          v-model="requestParams1.type"
          class="schoolKinds"
          placeholder="请选择"
          clearable
        >
          <el-option
            v-for="(item1, index1) in schoolTypes"
            :key="index1"
            :label="item1.name"
            :value="item1.id"
          />
        </el-select>
        <el-button class="btn" @click="init">
          查询
        </el-button>
      </div>
      <div v-if="data1&&data1.length" class="cell-list">
        <div v-for="(item2, index2) in data1" :key="index2" class="cell-item">
          <com-card2
            :obj="item2"
            :show-control="false"
            :img-height="imgHeight"
            img-width="auto"
            @path="handleRouteDto"
          />
        </div>
      </div>
      <div v-else class="NullData">
        <NullData />
      </div>
    </div>
  </section>
</template>

<script>
import mock from '@/utils/mock'

import NullData from '@/components/NullData'
import comCard2 from '@/components/comCard2'
export default {
  name: 'ComContrast',
  components: {
    comCard2,
    NullData
  },
  props: {
    imgHeight: {
      type: String,
      default: '200px'
    },
    schoolTypes: {
      type: Array,
      default: () => {
        return []
      }
    },
    areas: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      data1: null,
      loading: false,
      libraryInfo: mock.library.contrast.viewInfo,
      libraryInit: mock.library.contrast.init,
      requestParams1: {
        is_rec: 0,
        type: null,
        area_id: null,
        is_model_school: 0,
        is_model_library: 1,
        model_library_year: null,
        paeg: 1,
        page_size: 10
      }
    }
  },
  computed: {},
  watch: {},
  mounted() {
    this.loading = true
    this.init()
  },
  methods: {
    async init() {
      this.data1 = await this.libraryInit.data1(this.requestParams1)
      this.loading = false
    },
    handleRouteDto(v) {
      this.$router.push({
        path: '/library/contrast/details',
        query: {
          id: v.id
        }
      })
    },
    cancelSubmit() {
      this.$emit('input')
    }
  }
}
</script>
<style lang="scss" scoped>
.contrast {
  overflow: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
  .cell-list {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    // justify-content: space-between;
    .cell-item {
      // width: 23%;
      width: 342px;
      display: flex;
      flex-wrap: wrap;
      flex-direction: column;
      margin: 0 15px 15px 0;

      > section {

      }
    }
  }
}
.area {
  margin: 20px;
}
.schoolKinds {
  margin-left: 20px;
}
.btn {
  margin-left: 20px;
  @include fun-btn(4)
}
.NullData{
  width: 100%;
  height: 100%;
  background: #fff;
}
</style>
